import React from 'react'

export const ImageBackground = () => {
  return (
    <img src="/images/logo-bg.png" alt="" style={{
      width: '50%',
      position: 'fixed',
      left: '50%',
      bottom: -60,
      transform: 'translateX(-50%)',
      filter: 'blur(1px)',
      zIndex: -1,
      opacity: .8,
      animationDelay: '1s'
    }}/>
  )
}
